import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
  useCallback,
} from "react";
import AuthContext from "../context/auth/AuthContext";
import { Link, useLocation, useNavigate } from "react-router-dom";

// import '../assets/css/navbar.css'
import crossNew from "../assets/img/cross-new.svg";
import bellicon from "../assets/img/bell.png";
import eyeicon from "../assets/img/eye.png";
import logouticon from "../assets/img/logout.png";
import useTranslator from "../hooks/useTranslator";
import { haveValue, validatePhoneNumber } from "../helper/common";
import i18next from "i18next";
import { MdInfoOutline } from "react-icons/md";
import { Modal } from "react-bootstrap";
import LandLordContext from "../context/landlord/LandLordContext";
import QRCode from "react-qr-code";
import { toast } from "react-toastify";
import copy from "copy-to-clipboard";
import { FaRegCopy } from "react-icons/fa6";
import { IoMdDownload } from "react-icons/io";
import PhoneInput from "react-phone-input-2";

//NEED TO ADD FEATURE TO MAKE THE COUNT AS 0

function downloadBlob(blob, filename) {
  const objectUrl = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  setTimeout(() => URL.revokeObjectURL(objectUrl), 5000);
}

const Navbar = () => {
  const { _t } = useTranslator();
  const location = useLocation();
  const { getAgencyDetails, sendInvitationToTenant } =
    useContext(LandLordContext);

  const [currentLang, setCurrentLang] = useState(
    localStorage.getItem("i18nextLng").toLowerCase() || "en-us"
  );

  // Invite tenant statesS
  const svgRef = useRef();
  const [showInviteTenantModel, setShowInviteTenantModel] = useState(false);

  const handlecopyUrl = () => {
    copy(
      `https://${process.env.REACT_APP_URL_NAME}/home?requestProfileLink=${user?._id}`
    );
    toast.success(_t("linkCopied"));
  };

  const handleDownloadQR = useCallback(() => {
    const svg = svgRef.current.innerHTML;
    const blob = new Blob([svg], { type: "image/svg+xml" });
    downloadBlob(blob, `myimage.svg`);
  }, []);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showPhoneModal, setShowPhoneModal] = useState(false);
  const [sharerEmail, setSharerEmail] = useState(null);
  const [sharerPhone, setSharePhone] = useState(null);
  const [sharerName, setSharerName] = useState(null);

  const sendInvitationViaEmail = async (e) => {
    e.preventDefault();
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(sharerEmail)) {
      try {
        const response = await sendInvitationToTenant({
          type: "email",
          name: sharerName,
          email: sharerEmail,
        });
        const data = response.data;
        if (data.message) {
          toast.success(data.message);
        }
      } catch (error) {
        const response = error.response;
        if (response.data) {
          if (response.data.err) {
            toast.error(response.data.err);
          }
        }
      } finally {
        setSharerEmail(null);
        setShowEmailModal(false);
      }
    } else {
      toast.error(_t("invalidEmailAddress"));
      return false;
    }
  };

  const sendInvitationViaPhone = async (e) => {
    e.preventDefault();
    const validate = validatePhoneNumber(sharerPhone);
    if (!validate.isValid) {
      toast.error(validate.message);
      return false;
    } else {
      try {
        const response = await sendInvitationToTenant({
          type: "phone",
          name: sharerName,
          phone: sharerPhone,
        });
        const data = response.data;
        if (data.message) {
          toast.success(data.message);
        }
      } catch (error) {
        const response = error.response;
        if (response.data) {
          if (response.data.err) {
            toast.error(response.data.err);
          }
        }
      } finally {
        setSharePhone(null);
        setShowPhoneModal(false);
      }
    }
  };

  const [showModal, setShowModal] = useState(false);
  const [agencyDetails, setAgencyDetails] = useState(null);
  const [ureadCount, setUnreadCount] = useState(0);

  const authContext = useContext(AuthContext);
  const { isLoggedIn, user, notifications, userType, logout, changeUserLng } =
    authContext;
  const navigate = useNavigate();

  const takeMeToProfile = () => {
    navigate(`/${userType}-profile`);
  };

  useEffect(() => {
    var count = 0;
    if (notifications && notifications.length > 0) {
      notifications.forEach((val) => {
        if (val.marked_read == false) {
          count++;
        } else {
          return;
        }
      });
      setUnreadCount(count);
    }
  }, [notifications]);

  useEffect(() => {
    if (haveValue(user?.lang)) {
      const e = { target: { value: user?.lang } };

      handleLanguageChange(e);
    }
    getAgencyDetails()
      .then((res) => {
        setAgencyDetails(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [user]);

  const handleLanguageChange = async (e) => {
    var langVal = e.target.value;
    await i18next.changeLanguage(langVal);
    await changeUserLng();
    setCurrentLang(langVal);
  };

  return (
    <>
      <div id="header" className="head-cus">
        <div className="header-left float-left custom-header">
          <div className="firstaside">
            <h5>
              {_t("hi")} {user?.fname || user?.fname_companyName} {user?.lname}
            </h5>
          </div>
          <div className="second-aisde">
            {userType == "landlord" && (
              <div className="shareQr">
                <a
                  className="btn btngreen invite_tenantbtn"
                  href={undefined}
                  onClick={(e) => setShowInviteTenantModel(true)}
                >
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 26 23"
                    className="button_iconset"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.47555 11.6349C5.39143 11.8906 5.34412 12.1623 5.34412 12.4446C5.34412 13.8537 6.47445 15.0018 7.86765 15.0018C9.26086 15.0018 10.3912 13.8564 10.3912 12.4446C10.3912 11.0329 9.26086 9.8875 7.86765 9.8875C7.38398 9.8875 6.93447 10.0287 6.54805 10.2684L4.32156 8.28397L5.17588 7.31439L3.89308 6.15303L3.02825 7.13326L2.42628 6.5952L3.33843 5.56169L2.05563 4.40033L1.13296 5.44449L1.03307 5.55903L0.509965 6.15303L0.515222 6.15835L0 6.75502L5.47818 11.6349H5.47555ZM7.86765 11.6295C8.30927 11.6295 8.67203 11.9945 8.67203 12.442C8.67203 12.8895 8.3119 13.2544 7.86765 13.2544C7.42341 13.2544 7.06591 12.8895 7.06591 12.442C7.06591 11.9945 7.42603 11.6295 7.86765 11.6295Z"
                      fill="#253837"
                    />
                    <path
                      d="M7.18932 8.98668C7.20246 8.98401 7.52842 8.89611 7.9937 8.89611C8.98208 8.89611 10.3253 9.2637 11.1192 11.0111L11.1744 11.1309L12.7358 10.4011L12.6806 10.2812C11.7448 8.2222 10.1913 7.17804 8.05942 7.17804C7.65197 7.17804 7.21561 7.21799 6.76085 7.29524L6.6189 7.31921L7.06052 9.01598L7.18669 8.98135L7.18932 8.98668Z"
                      fill="#253837"
                    />
                    <path
                      d="M13.3878 1.76544C13.974 2.78296 15.9009 6.37892 16.0612 10.0095L16.0665 10.1454L17.783 10.0068L17.7751 9.87633C17.5701 6.60267 15.9324 2.96942 14.9756 1.09419C14.9466 1.03559 14.9282 1.00096 14.9204 0.984978L14.8651 0.865112L13.3037 1.59762L13.3589 1.71749C13.3589 1.71749 13.3694 1.73614 13.3852 1.76544H13.3878Z"
                      fill="#253837"
                    />
                    <path
                      d="M9.0006 2.0771C9.6788 2.86022 13.0829 6.93831 13.5167 10.2386L13.5351 10.3691L15.2385 10.14L15.2201 10.0095C14.7653 6.53876 11.6897 2.58586 10.3885 1.04626C10.3517 1.00364 10.3281 0.974341 10.3176 0.961023L10.2361 0.85714L8.89282 1.94392L8.97431 2.0478C8.97431 2.0478 8.98483 2.05846 8.99797 2.0771H9.0006Z"
                      fill="#253837"
                    />
                    <path
                      d="M19.0315 2.53771L18.9841 2.41518L17.3859 3.05979L17.4332 3.18232C19.8674 9.37803 20.1171 14.9211 18.1035 18.0083C16.5657 20.3657 13.9949 20.4483 13.8845 20.4509H13.8608C13.6006 20.4642 13.343 20.4696 13.0932 20.4696C10.3515 20.4696 8.21968 19.7131 6.75024 18.2214C4.28716 15.7202 4.25562 11.9645 4.25562 11.9298L4.26088 11.7993L3.40393 11.754L2.54697 11.7061L2.53909 11.8393C2.53909 11.8819 2.49966 16.3569 5.52264 19.4414C7.32592 21.2793 9.87312 22.2143 13.0959 22.2143C13.3693 22.2143 13.6505 22.2063 13.9318 22.193C14.2946 22.1823 17.5357 22.0118 19.523 18.9939C21.8993 15.382 21.7206 9.38336 19.0315 2.53771Z"
                      fill="#253837"
                    />
                    <path
                      d="M22.0475 10.6344C22.0475 10.1503 21.8552 9.686 21.5129 9.34367C21.1705 9.00134 20.7062 8.80902 20.2221 8.80902C19.738 8.80902 19.2737 9.00134 18.9314 9.34367C18.589 9.686 18.3967 10.1503 18.3967 10.6344V12.7614H16.2697C15.7856 12.7614 15.3213 12.9537 14.979 13.296C14.6367 13.6384 14.4443 14.1027 14.4443 14.5868C14.4443 15.0709 14.6367 15.5352 14.979 15.8775C15.3213 16.2199 15.7856 16.4122 16.2697 16.4122H18.3967V18.5392C18.3967 19.0233 18.589 19.4876 18.9314 19.8299C19.2737 20.1723 19.738 20.3646 20.2221 20.3646C20.7062 20.3646 21.1705 20.1723 21.5129 19.8299C21.8552 19.4876 22.0475 19.0233 22.0475 18.5392V16.4122H24.1745C24.6586 16.4122 25.1229 16.2199 25.4652 15.8775C25.8076 15.5352 25.9999 15.0709 25.9999 14.5868C25.9999 14.1027 25.8076 13.6384 25.4652 13.296C25.1229 12.9537 24.6586 12.7614 24.1745 12.7614H22.0475V10.6344Z"
                      fill="#253837"
                      stroke="#A3EB64"
                      stroke-width="2"
                    />
                  </svg>
                  {_t("requestProfile")}
                </a>
              </div>
            )}
            <div class="menu-togglebar">
              <label class="customradiobtn">
                <input
                  type="radio"
                  onClick={handleLanguageChange}
                  checked={
                    currentLang == "en-us" || currentLang == "en-US"
                      ? "checked"
                      : ""
                  }
                  name="radio"
                  value={"en-us"}
                />
                <span class="checkmark1">{_t("en")}</span>
              </label>
              <label class="customradiobtn">
                <input
                  type="radio"
                  onClick={handleLanguageChange}
                  checked={currentLang == "es" ? "checked" : ""}
                  name="radio"
                  value={"es"}
                />
                <span class="checkmark1">{_t("es")}</span>
              </label>
            </div>
            <div className="slideryt">
              <div className="re-div">
                <div className="dropdown admin-btn">
                  <Link data-bs-toggle="dropdown">
                    <div className="admin-name">
                      {userType == "landlord" ? (
                        haveValue(agencyDetails) &&
                        haveValue(agencyDetails?.company_name) &&
                        haveValue(agencyDetails?.company_logo) ? (
                          <img
                            id="navbar_ll_image"
                            src={`${process.env.REACT_APP_SERVER_URL}/uploads/${agencyDetails?.company_logo}`}
                            alt=""
                          />
                        ) : (
                          <>
                            {user?.fname_companyName &&
                              user?.fname_companyName.charAt(0).toUpperCase()}
                            {user?.lname && user?.lname.charAt(0).toUpperCase()}
                          </>
                        )
                      ) : (
                        <>
                          {user?.fname && user?.fname.charAt(0).toUpperCase()}
                          {user?.lname && user?.lname.charAt(0).toUpperCase()}
                        </>
                      )}
                    </div>

                    <ul className="dropdown-menu">
                      <div
                        className="hover-dropdown"
                        style={{ display: "block" }}
                      >
                        <Link onClick={takeMeToProfile}>
                          <img src={eyeicon} alt="" /> {_t("viewProfile")}
                        </Link>
                        <Link
                          onClick={(e) => setShowModal(true)}
                          className="pb-0"
                        >
                          <img src={logouticon} alt="" /> {_t("logout")}
                        </Link>
                      </div>
                    </ul>
                  </Link>
                </div>
                {/* <div className="hover-dropdown">
                              <a href="#" className="mt-1"><img src="./img/eye.png" alt=""/> View Profile</a>
                              <a href="#"><img src="./img/logout.png" alt=""/> Log Out</a>
                           </div> */}
              </div>
              <div>
                <Link to="/notification">
                  <span className="badge text-white">{ureadCount}</span>
                  <img src={bellicon} alt="" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      {userType == "tenant" && (
        <>
          <div id="sub-header-links" className="">
            {/* <div className="row"> */}
            <div className=" sub-head-links-wrapper">
              <div
                className={`sub-link ${
                  location.pathname == "/tenant" && "active"
                }`}
              >
                <Link to="/tenant">{_t("myDashBoard")}</Link>
              </div>
              <div
                className={`sub-link ${
                  location.pathname == "/profile-shared" && "active"
                } ${
                  user?.onfido_kyc_success || user?.kyc_success
                    ? ""
                    : "disabled_nav"
                }`}
              >
                <Link to="/profile-shared" className="">
                  {_t("profileShared")}
                </Link>
              </div>
              <div
                className={`sub-link ${
                  location.pathname == "/tenant/review/rental" && "active"
                } ${user?.rent_paid ? "" : "disabled_nav"}`}
              >
                <Link to="/tenant/review/rental" className="">
                  {_t("rentDetails")}
                </Link>
              </div>
            </div>
            {/* </div> */}
          </div>
        </>
      )}
      <Modal show={showModal} centered className="newmodalui asguarantor">
        <Modal.Header></Modal.Header>
        <Modal.Body>
          <div className="forminput row100">
            {_t("areYouSureYouWantToLogout")}
          </div>
          <div className="btngroup row100 gridbar">
            <button
              className="btn btnoutline cancel-btn"
              type="button"
              onClick={(e) => setShowModal(false)}
            >
              {_t("cancel")}
            </button>
            <button className="btn btnorange" type="button" onClick={logout}>
              {_t("logout")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={showInviteTenantModel}
        onHide={(e) => setShowInviteTenantModel(false)}
        centered
        className="newmodalui max-w-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>{_t("yourProfileQR")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="qr-code-div qrcode-copy" ref={svgRef}>
            <QRCode
              id="qr_code_image"
              value={`https://${process.env.REACT_APP_URL_NAME}/home?requestProfileLink=${user?._id}`}
            />
          </div>
          <div className="qr-link-copi share-and-copy-div">
            <input
              type="text"
              disabled
              value={`https://${process.env.REACT_APP_URL_NAME}/home?requestProfileLink=${user?._id}`}
            />
            <button type="button" onClick={handlecopyUrl}>
              <FaRegCopy />
              {_t("copyURL")}
            </button>
          </div>
          <div className="qr-code-download">
            <a href={undefined} onClick={handleDownloadQR}>
              <IoMdDownload />
              {_t("downloadNow")}
            </a>
          </div>
          <div className="d-flex justify-content-center gap-2 align-items-center m-3">
            <button
              type="button"
              onClick={() => {
                setShowEmailModal(true);
                setShowInviteTenantModel(false);
              }}
              className="btn btngreen"
            >
              {_t("shareViaEmail", "Landlord side in tenant profile section")}
            </button>
            <button
              type="button"
              onClick={() => {
                setShowPhoneModal(true);
                setShowInviteTenantModel(false);
              }}
              className="btn btngreen"
            >
              {_t("shareViaPhone", "Landlord side in tenant profile section")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={showEmailModal}
        onHide={(e) => setShowEmailModal(false)}
        centered
        className="newmodalui max-w-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>{_t("email")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="qr-link-copi"> */}
          <form
            onSubmit={sendInvitationViaEmail}
            className="d-flex flex-wrap mt-5 justify-content-center"
          >
            <div className="form-group col-6 px-1 bodyContentset">
              <input
                type="text"
                onChange={(e) => {
                  setSharerName(e.target.value);
                }}
                className="form-control"
                required={true}
                placeholder={_t("name")}
              />
            </div>
            <div className="form-group col-6 px-1 bodyContentset">
              <input
                type="email"
                onChange={(e) => {
                  setSharerEmail(e.target.value);
                }}
                className="form-control"
                required={true}
                placeholder={_t("email")}
              />
            </div>
            <div className="col-12 mt-3  d-flex justify-content-center">
              <button type="submit" className="btn btngreen">
                {_t("sendInvitation")}
              </button>
            </div>
          </form>
          {/* </div> */}
        </Modal.Body>
      </Modal>
      <Modal
        show={showPhoneModal}
        onHide={(e) => setShowPhoneModal(false)}
        centered
        className="newmodalui max-w-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>{_t("phone")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            onSubmit={sendInvitationViaPhone}
            className="d-flex flex-wrap mt-5 justify-content-center"
          >
            <div className="form-group col-6 px-1 bodyContentset">
              <input
                type="text"
                onChange={(e) => {
                  setSharerName(e.target.value);
                }}
                className="form-control"
                required={true}
                placeholder={_t("name")}
              />
            </div>
            <div className="form-group col-6 px-1 bodyContentset">
              <PhoneInput
                className="custom-input phone_input"
                international
                country={"es"}
                value={sharerPhone}
                onChange={(e) => setSharePhone(e)}
              />
            </div>
            <div className="col-12 mt-3 d-flex justify-content-center">
              <button type="submit" className="btn btngreen">
                {_t("sendInvitation")}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Navbar;
